import Modal from '../../Modal';
import Close from '../../../../assets/icons/Close';

import { Title, SubTitle, Container, DivIcon } from './styles';
import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { toastAlert } from '../../../Toastify/index';
import { handleListFlowAccountable } from '../../../../state/users/actions';
import Accountable from '../../Accountable/index';
import {
  handleUpdateAccountable,
  handleRemoveAccountable,
} from '../../../../state/activedFlows/actions';

const ChangeUserFlowModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
}) => {
  const flow = useSelector((state) => state.activedFlows.pane.flow);
  const accountable = flow.accountable;

  const [listAccountables, setListAccountables] = useState([]);

  const handles = {
    updateAcc: handleUpdateAccountable,
    removeAcc: handleRemoveAccountable,
  };

  const dispatch = useDispatch();

  async function fetchAccountables() {
    try {
      const res = await dispatch(handleListFlowAccountable());
      setListAccountables(res.data.usersByTenant);
    } catch (err) {
      toastAlert({
        msg: `Ocorreu um erro ao buscar usuários disponiveis: ${err}`,
        isError: true,
      });
    }
  }

  useEffect(() => {
    fetchAccountables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Alterar Responsável</Title>
        <SubTitle>
          Defina o responsável por delegar e permitir ações no fluxo.
        </SubTitle>

        <Accountable
          subtitle="Responsável do fluxo"
          accountable={accountable}
          list={listAccountables}
          id={flow._id}
          handles={handles}
        />

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ChangeUserFlowModal;
